import React from 'react';
import footerStyle from '../styles/footer.module.scss'
import { Link } from 'gatsby'
import '../styles/button.scss'
import { IoLogoLinkedin } from "react-icons/io";
import { IoLogoInstagram } from "react-icons/io";
import { IoLogoGithub } from "react-icons/io";

import LogoWhite from './logo-white'
import Gatsby from "../assets/Gatsby_Logo_white.svg"

const today = new Date();
const year = today.getFullYear();
 
const Footer = () => (
 <footer className={footerStyle.footer}>
      <div className={footerStyle.footer_wrap}>

            <div className={footerStyle.footer_up}>

                <div className={footerStyle.footer_logo_responsive}>
                <LogoWhite />
                </div>

                <div className={footerStyle.footer_up_left}>
                    <LogoWhite />
                    <div className={footerStyle.footer_up_left_address}> 
                        <address>
                            Av. Europa, 14<br/>
                            41907 Valencina de la Concepción<br/>
                            Sevilla
                        </address>
                        <a href="tel:680719754">680719754</a><br/>
                        <a href="mailto:felixdigitalco@gmail.com">felixdigitalco@gmail.com</a>
                    </div>
                </div>
                    
            

                <div className={footerStyle.footer_up_right}>
                    <div className={footerStyle.footer_up_right_menu}>
                        <ul className={footerStyle.footer_up_right_menu_ul}>
                            <li className={footerStyle.footer_up_right_menu_ul_li}>
                                <Link to="/">Inicio</Link>
                            </li>
                            <li className={footerStyle.footer_up_right_menu_ul_li}>
                                <Link to="/sobre-mi">¿Quién soy?</Link>
                            </li>
                            <li className={footerStyle.footer_up_right_menu_ul_li}>
                                <span>Servicios</span>
                                <ul className={footerStyle.footer_up_right_submenu}>
                                    <li className={footerStyle.footer_up_right_submenu_item}>
                                        <Link to="diseno-web-sevilla">Diseño web</Link>
                                    </li>
                                    <li className={footerStyle.footer_up_right_submenu_item}>
                                        <Link to="diseno-tienda-online-sevilla">Tienda Online</Link>
                                    </li>
                                    <li className={footerStyle.footer_up_right_submenu_item}>
                                        <Link to="diseno-web-sevilla">Landing page</Link>
                                    </li>
                                </ul>
                            </li>
                            <li className={footerStyle.footer_up_right_menu_ul_li}>
                                <Link to="/portfolio">Portfolio</Link>
                            </li>
                            <li className={footerStyle.footer_up_right_menu_ul_li}>
                                <Link to="/blog">Blog</Link>
                            </li>
                            <li className={footerStyle.footer_up_right_menu_ul_li}>
                                <Link to="/contacto">Contacto</Link>
                            </li>
                        </ul>

                    </div>
                </div>
                
        
            </div>

            <div className={footerStyle.footer_bottom}>   
                    
                <div className={footerStyle.footer_bottom_left}>
                    <Link to="/aviso-legal" rel="nofollow">Aviso legal</Link> — <Link to="/politica-privacidad" rel="nofollow">Política de privacidad</Link> — <Link to="/politica-cookies" rel="nofollow">Política de cookies</Link>
                    <p>© {year} felixdigital.es</p>
                </div>
              

                <div className={footerStyle.footer_bottom_right}>
                    <Link to='https://www.linkedin.com/in/jfelixgonzalo/' target='_blank' rel="noopener noreferrer nofollow" aria-label='Linkedin'>
                            <IoLogoLinkedin className={footerStyle.footer_bottom_right_icon} id='linkedin'/>
                    </Link>

                    <Link to='https://www.instagram.com/felixdigitalco/' target='_blank' rel="noopener noreferrer nofollow" aria-label='Instagram'>
                            <IoLogoInstagram className={footerStyle.footer_bottom_right_icon} id='instagram'/> 
                    </Link>
                        
                    <a href='https://github.com/jotafelix/' target='_blank' rel="noopener noreferrer nofollow" aria-label='Github'>
                            <IoLogoGithub className={footerStyle.footer_bottom_right_icon} id='github'/>
                    </a>
                        
                </div>

            </div>

            <div className={footerStyle.made}>
                <p className={footerStyle.made_gatsby}>Web desarrolada con <a href="https://www.gatsbyjs.org/" target='_blank' rel="noopener noreferrer"><Gatsby /></a></p>
            </div>
      </div>
      

  </footer>
);


export default Footer